import AnonymousIcon from './AnonymousIcon.component';

export default AnonymousIcon;
